/**
 * sync.js — local retag + registry learning (no server).
 * Cross-device moves use the encrypted vault (src/utils/vault.js).
 */
import { db } from './db';

// ── Retag — local-only; Pro vault carries overrides across devices ──
export async function handleRetag({ userId, merchantKey, newCategory, newSubcategory, applyToAll, txnId }) {
    await db.user_overrides.put({
        user_id: userId,
        merchant_key: merchantKey,
        category: newCategory,
        subcategory: newSubcategory,
        updated_at: new Date().toISOString(),
    });

    // Local learning flywheel — powers T2/T7 on next upload
    try {
        const existing = await db.merchant_registry.get(merchantKey);
        const vote_count = (existing?.vote_count || 0) + 1;
        await db.merchant_registry.put({
            merchant_key: merchantKey,
            category: newCategory,
            subcategory: newSubcategory,
            vote_count,
            confidence: Math.min(0.99, 0.8 + vote_count * 0.03),
            updated_at: new Date().toISOString(),
        });
    } catch {
        // registry optional
    }

    const patch = {
        category: newCategory,
        subcategory: newSubcategory,
        category_source: 'user',
        confidence: 1.0,
    };

    let updated = 0;
    if (applyToAll) {
        updated = await db.transactions.where('merchant_key').equals(merchantKey).count();
        await db.transactions.where('merchant_key').equals(merchantKey).modify(patch);
    } else if (txnId) {
        await db.transactions.update(txnId, patch);
        updated = 1;
    }

    return updated;
}

// Stubs — no-ops in MVP
export async function flushSyncQueue() {}
export async function fetchOverridesFromServer() {}
export async function recalculateAndQueueSummary() {}
export async function syncGoals() {}
export async function syncBudgets() {}
